var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import React from "react";
var FundtransferBtn = function (props) {
    return (React.createElement("div", { className: " ".concat(props.parentClass, " bottombtngroup d-flex justify-content-around align-content-center") },
        React.createElement(React.Fragment, null,
            props.btnvalueleft && React.createElement(EdButton, __assign({}, props.btnvalueleft)),
            props.btnvalueright && React.createElement(EdButton, __assign({}, props.btnvalueright)))));
};
export default FundtransferBtn;
